import {Text} from '@chakra-ui/react'
import {useTranslation} from 'next-i18next'

export const PrivacyPolicy = () => {
  const { t } = useTranslation('checkout')
  return (
    <Text
      textStyle="body2"
      mt={{ base: 6, md: 'unset' }}
      fontSize="12px"
      lineHeight={1.5}
      mx={{ base: 4, lg: 0 }}
    >
      {t('PRIVACY_POLICY')}
    </Text>
  )
}
